/**
 * Mixpanel Analytics Constants
 *
 * Centralized enums for Mixpanel event tracking to ensure consistency
 * and prevent typos across the application.
 */

/**
 * Flow categories for organizing events by feature area
 * Used as the middle part in event names: "Cured: {Flow} - {Event}"
 */
export enum MixpanelFlow {
    CAMPAIGN = 'Campaign',
    INSIGHTS = 'Insights',
    CONTENT = 'Content',
    AUDIENCE = 'Audience',
    CONTACTS = 'Contacts',
}

/**
 * Campaign flow types for tracking different campaign creation paths
 * Used in event properties to distinguish between campaign types
 */
export enum CampaignFlowType {
    SINGLE_SEND = 'single_send',
    EMAIL_SERIES = 'email_series',
    CONDITIONAL_SPLIT = 'conditional_split',
    CUSTOM_CAMPAIGN = 'custom_campaign',
}

/**
 * Event names for tracking user actions
 * Used as the last part in event names: "Cured: {Flow} - {Event}"
 */
export enum MixpanelEvent {
    // Campaign Events
    NEW_CAMPAIGN_START = 'New Campaign Start',
    CAMPAIGN_PUBLISHED = 'Campaign Published',
    DRAFT_CAMPAIGN_SAVED = 'Draft Campaign Saved',
    CAMPAIGN_ABANDONED = 'Campaign Abandoned',
    AUDIENCE_SELECTED = 'Audience Selected',
    CONTENT_ADDED = 'Content Added',
    SCHEDULE_SET = 'Schedule Set',

    // Insights Events
    DASHBOARD_FILTERS_APPLIED = 'Dashboard Filters Applied',

    // Future events can be added here
    // CONTENT_CREATED = 'Content Created',
    // AUDIENCE_CREATED = 'Audience Created',
    // etc.
}
